import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { FETCH_SPAM_RANGE } from "../actions/spamAction";

const spamsReducer = (
    state = {
        spamRangeSettings: null,
        spamRangeLoading: false,
    },
    action,
) => {
    switch (action.type) {
        case isFulfilled(FETCH_SPAM_RANGE):
            return (state = {
                ...state,
                spamRangeLoading: false,
                spamRangeSettings: action.payload.data.company.beacon_range_setting[0].range.split(",").map((x) => Number(x)),
            });

        default:
            return state;
    }
};

export default spamsReducer;
